import { createFileRoute } from '@tanstack/react-router';

import { DealIntelligencePage } from '@/features/deal-intelligence/components/DealIntelligencePage';
import { PlatformRestriction } from '@/shared/navigation/components/PlatformRestriction';

/**
 * `lastGap` carries the gap the reader just came back from. It lives in the
 * URL rather than component state so the restored scroll position and the
 * highlight survive a reload.
 */
export interface ProjectGapsSearch {
  lastGap?: string;
}

export const Route = createFileRoute(
  '/_dashboard/deal-intelligence_/project/$projectId'
)({
  validateSearch: (search: Record<string, unknown>): ProjectGapsSearch => ({
    lastGap: typeof search.lastGap === 'string' ? search.lastGap : undefined,
  }),
  component: ProjectGapsRoute,
});

function ProjectGapsRoute() {
  const { projectId } = Route.useParams();
  const { lastGap } = Route.useSearch();
  return (
    <PlatformRestriction notAllowedPlatforms={['mobile']}>
      <DealIntelligencePage
        projectExternalId={projectId}
        lastViewedGapId={lastGap}
      />
    </PlatformRestriction>
  );
}
